import { Button, Group, Text } from '@mantine/core';
import { IconLifebuoy } from '@tabler/icons-react';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { visiUserData } from '../../GeneralFunction';
import LoginLogoutApi from '../../api/LoginLogoutApi';

export const SupportModeBanner = () => {

  const [returning, setReturning] = useState(false);
  // subscribing to the route keeps the banner in sync once the support session is stored
  useLocation();
  const userData = visiUserData();

  if (!userData || Number(userData.is_support) !== 1) {
    return null;
  }

  const adminUrl = userData.return_admin_url || (process.env.REACT_APP_OLD_VISIOPT_BASE_URL + 'admin/index.php');

  const handleReturnToAdmin = () => {
    setReturning(true);
    // the session is cleared either way so support is never left stranded inside the account
    LoginLogoutApi.supportlogout()
      .finally(() => {
        localStorage.removeItem('visiUserData');
        localStorage.removeItem('visiMemberData');
        window.location.href = adminUrl;
      });
  };

  return (
    <div style={{ backgroundColor: '#B54708', color: '#ffffff', padding: '8px 16px' }}>
      <Group position="apart" noWrap>
        <Group spacing="xs" noWrap>
          <IconLifebuoy size={18} />
          <Text size="sm" weight={600}>
            Support Mode &ndash; Logged in as {userData.support_customer_name}
            {userData.support_admin_name ? ' (by ' + userData.support_admin_name + ')' : ''}
          </Text>
        </Group>
        <Button size="xs" variant="white" color="dark" loading={returning} onClick={handleReturnToAdmin}>
          Return to Admin
        </Button>
      </Group>
    </div>
  );
};
